import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://supabase.abhaev.store'
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY ||
    'eyJhbGciOiAiSFMyNTYiLCAidHlwIjogIkpXVCJ9.eyJyb2xlIjogImFub24iLCAiaXNzIjogInN1cGFiYXNlIiwgImlhdCI6IDE3NDE4MjQwMDAsICJleHAiOiAxODk5NTkwNDAwfQ.GiRQULYRsaWw6w9X5yF6IGQ6OvAgJAmjmIM2Kc_Atj0'

export const supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: false,
    },
})

/**
 * Upload a file to Supabase Storage and return the public URL.
 * @param {string} bucket  - Storage bucket name (e.g. 'customer-documents')
 * @param {string} folder  - Folder path inside bucket (e.g. 'customers')
 * @param {File}   file    - The File object to upload
 * @returns {Promise<string>} Public URL of the uploaded file
 */
export async function uploadToStorage(bucket, folder, file) {
    const ext = file.name.split('.').pop()
    const path = `${folder}/${Date.now()}.${ext}`
    const { error } = await supabase.storage.from(bucket).upload(path, file, { upsert: true })
    if (error) throw error
    return `${supabaseUrl}/storage/v1/object/public/${bucket}/${path}`
}
